import React from "react";

function RoleActivity({ chart_data }) {
  const data = Array.isArray(chart_data) ? chart_data : [];
  const colorClasses = [
    "border-primary",
    "border-success",
    "border-purple",
    "border-warning",
    "border-danger",
    "border-info",
  ];
  if (!data.length) {
    return <div className="text-muted">No Data Available</div>;
  }

  return (
    <>
      {data.map((emp, index) => (
        <div key={emp.id} className="shadow-none mb-2">
           <div className="border border-dashed bg-transparent-light rounded p-2 mb-2">
  <div className="d-flex align-items-center w-100">
    
    <span
      className={`d-block border border-2 h-12 rounded-5 me-2 ${
        colorClasses[index % colorClasses.length]
      }`}
    ></span>

    <div className="d-flex justify-content-between align-items-start w-100">

      {/* Left Side */}
      <div className="d-flex flex-column">
        <span className="fs-13 text-muted">
          {emp.role_name} - {emp.company_name}
        </span>

        <span className="fs-12 text-muted">
          {emp.candidate_name} - Status is {emp.status}
        </span>
      </div>

      {/* Right Side */}
      <div className="d-flex flex-column">
        <span className="fs-13 text-muted">
            {emp.user_name}
        </span>
      </div>

    </div>
  </div>
</div>
            </div>
        ))}
    </>
  );
}

export default RoleActivity;